import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { ChevronDown, ChevronRight, CreditCard, Link2, Plus } from "lucide-react";
import { api } from "@/lib/api";

export const MissingMealCardPanel = ({ refreshKey }) => {
  const [data, setData] = useState({ rows: [], free_cards: [] });
  const [open, setOpen] = useState(false);
  const [pick, setPick] = useState({});
  const [kno, setKno] = useState({});

  const load = () => api.get("/payroll/meal-cards/missing").then((r) => setData(r.data)).catch(() => {});
  useEffect(() => { load(); }, [refreshKey]);
  if (!data.rows.length) return null;

  const cardBody = (c, pid) => ({
    kart_adi: c.kart_adi, kart_no: String(c.kart_no), kullanici_adi: c.kullanici_adi || "", telefon: c.telefon || "",
    cep: c.cep || "", email: c.email || "", kart_tipi: c.kart_tipi || "Fiziki Kart", hediye: c.hediye || "Hayır",
    sube: c.sube || "MERKEZ", personnel_id: pid,
  });
  const link = async (p) => {
    const c = data.free_cards.find((x) => x.id === pick[p.id]);
    if (!c) return;
    try { await api.put(`/payroll/meal-cards/${c.id}`, cardBody(c, p.id)); toast.success(`${p.ad_soyad} · ${c.kart_no} bağlandı`); load(); }
    catch { toast.error("Bağlanamadı"); }
  };
  const create = async (p) => {
    const no = (kno[p.id] || "").trim();
    if (!no) return;
    try {
      await api.post("/payroll/meal-cards", cardBody({ kart_adi: p.ad_soyad, kart_no: no }, p.id));
      toast.success(`${p.ad_soyad} · yeni kart ${no} eklendi`); load();
    } catch { toast.error("Eklenemedi"); }
  };
  const inp = "px-2 py-1 border border-slate-300 rounded text-xs";

  return (
    <div className="mx-4 md:mx-5 mt-3 border border-teal-300 bg-teal-50 rounded-lg" data-testid="missing-card-panel">
      <button type="button" onClick={() => setOpen(!open)} data-testid="missing-card-toggle"
        className="w-full flex items-center gap-2 px-3 py-2 text-left text-sm font-semibold text-teal-900">
        <CreditCard size={15} className="text-teal-700" />
        <span data-testid="missing-card-count">{data.rows.length} aktif personelin Pluxee yemek kartı yok</span>
        <span className="text-[11px] font-normal text-teal-700">· {data.free_cards.length} boşta kart var</span>
        <span className="ml-auto">{open ? <ChevronDown size={15} /> : <ChevronRight size={15} />}</span>
      </button>
      {open && (
        <div className="px-3 pb-3 space-y-1.5">
          {data.rows.map((p) => (
            <div key={p.id} className="flex items-center gap-2 flex-wrap bg-white border border-teal-200 rounded-md px-2 py-1.5" data-testid={`missing-card-row-${p.sicil_no}`}>
              <div className="min-w-[170px] flex-1">
                <div className="text-sm font-semibold text-slate-900">{p.ad_soyad}</div>
                <div className="text-[11px] text-slate-500">{p.pozisyon}</div>
              </div>
              <select className={`${inp} w-56`} value={pick[p.id] || ""} onChange={(e) => setPick({ ...pick, [p.id]: e.target.value })} data-testid={`missing-card-pick-${p.sicil_no}`}>
                <option value="">— boştaki kartı seç —</option>
                {data.free_cards.map((c) => <option key={c.id} value={c.id}>{c.kart_no} · {c.kart_adi}{c.ilgili_text ? ` (${c.ilgili_text})` : ""}</option>)}
              </select>
              <button onClick={() => link(p)} disabled={!pick[p.id]} data-testid={`missing-card-link-${p.sicil_no}`}
                className="inline-flex items-center gap-1 px-2 py-1 bg-teal-700 text-white rounded text-xs font-semibold disabled:opacity-40"><Link2 size={12} /> Bağla</button>
              <span className="text-[11px] text-slate-400">veya</span>
              <input className={`${inp} w-28 font-mono`} placeholder="Yeni kart no" value={kno[p.id] || ""} onChange={(e) => setKno({ ...kno, [p.id]: e.target.value })} data-testid={`missing-card-new-${p.sicil_no}`} />
              <button onClick={() => create(p)} disabled={!(kno[p.id] || "").trim()} data-testid={`missing-card-create-${p.sicil_no}`}
                className="inline-flex items-center gap-1 px-2 py-1 border border-teal-600 text-teal-700 rounded text-xs font-semibold disabled:opacity-40"><Plus size={12} /> Ekle</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
